/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum ESpeedType {
  None = 0,
  PostedSpeed = 1,
  RoadSpeed = 2
}
